module.exports = __webpack_public_path__ + "img/registration.8204a137.svg";